import {Theme} from '@yandex-lego/components/Theme';

import './surveys/color.css';
import './surveys/root.css';

export const theme: Theme = {
    color: 'surveys-common',
    root: 'surveys-common'
};
